import React, { useEffect } from 'react';
import { Button, Form, Upload } from 'antd';




import { useDispatch } from 'react-redux';
import { UploadOutlined } from '@ant-design/icons';

function UploadFile({ onChange, auth, label }) {
    const [file, setFile] = React.useState();

    const conf = (auth, setFile) => {
        return {
            multiple: false,
            // listType: "picture",
            maxCount: 1,
            // showUploadList: false,
            accept: ".xlsx",
            onRemove: () => {
                setFile(undefined)
            },
            beforeUpload: (f) => {
                setFile(f)
                return false;
            }
        }
    };

    useEffect(() => {
        onChange(file)
    }, [file])

    return (
        <Upload {...conf(auth, setFile)}>
            {(!file) &&
                <Button type='text' icon={<UploadOutlined />}>{label}</Button>
            }
        </Upload>
    )
}

export default function LoadUserInfo(props) {
    const { auth, form, object } = props;
    const dispatch = useDispatch();

    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <div /*className='bg bg-grey'*/ style={{ marginBottom: "10px", textAlign: "left", padding: "5px" }}>
                    <div style={{ fontWeight: "600", paddingLeft: "5px" }}>
                        Файл
                    </div>
                    <Form.Item name="file" style={{ margin: "0px" }}>
                        <UploadFile auth={auth} label="Загрузить файл информации о пользователях" />
                    </Form.Item>
                </div>
            </Form>
        </>
    );
}
